import script from "./EnemyInfoBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./EnemyInfoBar.vue?vue&type=script&setup=true&lang=ts"

import "./EnemyInfoBar.vue?vue&type=style&index=0&id=012bcea8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-012bcea8"]])

export default __exports__